import api from './api';

// Permanent QR photo-collection inbox. Owner endpoints are authenticated (Bearer
// injected by the api instance); the two /u/:slug endpoints are public.
const photoCollectorService = {
    // ── Owner (authenticated) ──────────────────────────────────────────────
    // Config + current queue for an office space.
    get: (officeSpaceId) => api.get('/api/photo-collector', { params: { officeSpaceId } }),
    // Poll just the queue.
    getQueue: (officeSpaceId) => api.get('/api/photo-collector/queue', { params: { officeSpaceId } }),
    // Update settings: { enabled, maxQueueSize, expireHours }.
    updateConfig: (officeSpaceId, body) => api.patch('/api/photo-collector', body, { params: { officeSpaceId } }),
    // Rotate the slug — old QR/poster stops working.
    regenerate: (officeSpaceId) => api.post('/api/photo-collector/regenerate', {}, { params: { officeSpaceId } }),
    removeUpload: (id) => api.delete(`/api/photo-collector/queue/${id}`),
    clearQueue: (officeSpaceId) => api.delete('/api/photo-collector', { params: { officeSpaceId } }),
    // Fetch a queued PHOTO as a Blob (Bearer header injected — an <img src> can't
    // send it, so we fetch → object URL). thumb=true returns a small version.
    imageBlob: (id, thumb = false) =>
        api.get(`/api/photo-collector/queue/${id}/image`, {
            params: thumb ? { thumb: 1 } : {},
            responseType: 'blob',
        }),
    // Fetch a queued FILE (a PDF) as a Blob — same reason as above.
    fileBlob: (id) =>
        api.get(`/api/photo-collector/queue/${id}/file`, { responseType: 'blob' }),
    // The shop is done with these (printed / downloaded). A PRIVATE one — the customer asked for that — is
    // deleted for good; any other stays for its normal expiry. → { deleted: [ids], kept: [ids] }
    done: (ids) => api.post('/api/photo-collector/queue/done', { ids }),

    // ── Public (customer phone, no auth) ───────────────────────────────────
    publicView: (slug) => api.get(`/api/photo-collector/u/${slug}`),
    // One photo or PDF per call — formData: { file, phone, private: '1' | '0' }.
    upload: (slug, formData) =>
        api.post(`/api/photo-collector/u/${slug}/upload`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            timeout: 60000,
        }),
};

export default photoCollectorService;
